import { FullPageDotLoading } from '@xing-com/crate-jobs-components-full-page-dot-loading';
import { LoadingError } from '@xing-com/crate-jobs-domain-apply-components';
import type { InstantApplyJobDataXingletProps } from '@xing-com/crate-jobs-domain-apply-types';
import { JobsXingletWrapper } from '@xing-com/crate-jobs-xinglets';

export const InstantApplyLoggedIn =
  JobsXingletWrapper<InstantApplyJobDataXingletProps>(
    '@xing-com/crate-jobs-domain-instant-apply-logged-in',
    <FullPageDotLoading />,
    <LoadingError
      refetch={() => {
        window.location.reload();
      }}
    />
  );
